import { MenuItem, TreeNode } from "primeng/api";

export class Common {
    showLoading: boolean = false;
    isSearching: boolean = false;
    isTopLevel: boolean = true;
    breadcrumbs: Breadcrumb[] = [];
    folders: TreeNode[] = [];
    files: TreeNode[] = [];
    filter: string;
    selectedFolder: TreeNode;
    getCurrentFolderPath(): string {
        return this.breadcrumbs[this.breadcrumbs.length - 1].path;
    }
    getParentFolderPath(): string {
        let index =
            this.breadcrumbs.length >= 2
                ? this.breadcrumbs.length - 2
                : this.breadcrumbs.length - 1;
        return this.breadcrumbs[index].path;
    }
}

export class Standard extends Common {
    urlLink: string;
    accept: string;
    simpleView: boolean = false;
    contextMenu: MenuItem[];
    uploadFilesAllowed: boolean = false;
    currentFolder: TreeNode;
}

export class Modal extends Common {
    isCopy: boolean;
    isFile: boolean;
}

export class Breadcrumb {
    name: string;
    path: string;
}

export class NodeData {
    id: number;
    editable: boolean = false;
    originalPath: string = "";
    self: TreeNode = {};
    parent: TreeNode = {};
    hidden: boolean = false;
    url?: string;
    fileName?: string;
    date: Date;
    path?: string;
    options: any;
    isUrl: boolean = false;
    file?: any;
    addedBy?: string;
    modifiedBy?: string;
    modifiedDate?: Date;
    revisionNumber?: number;

    constructor(originalPath: string) {
        this.originalPath = originalPath;
    }

    getPath(): string {
        if (this.path) return this.path;

        let result = "";
        if (this.parent)
            result = (this.parent.data as NodeData).getPath() + "/";

        return result + this.self.label;
    }

    resetPath(): void {
        this.path = null;
        this.path = this.getPath();
    }
}

export class DuplicateFile {
    existingName: string;
    duplicates: TreeNode[];
    newFile: any;
}

export class AttachmentFile {
    clientId: number;
    path: string;
    useDelimiter: boolean;
}

export class File {
    addedBy: string;
    date: Date;
    file: any;
    fileName: string;
    hidden: boolean;
    metadata: Map<string, string>;
    modifiedBy: string;
    modifiedDate: Date;
    name: string;
    path: string[];
    revisionNumber: number;
    unalteredFileName?: string;
    url: string;
    webkitRelativePath?: string;

    static map(entity: any): File {
        return {
            date: entity.date,
            fileName: entity.originalfilename || entity.fileName || entity.name,
            metadata: entity.metadata,
            path: entity.path,
            url: entity.url,
            hidden: entity.hidden || false,
            file: entity.file,
            name: entity.originalfilename || entity.fileName || entity.name,
            addedBy: entity.addedBy,
            modifiedBy: entity.modifiedBy,
            modifiedDate: entity.modifiedDate,
            revisionNumber: entity.revisionNumber,
        };
    }
}

export class Folder {
    folderName: string;
    type: string;
    relativeFilePath: string;
    addedBy?: string;
    modifiedBy?: string;
    createdDate?: Date;
    modifiedDate?: Date;

    static map(entity: any): Folder {
        return {
            folderName: entity.folderName,
            relativeFilePath: entity.relativeFilePath,
            type: "Folder",
            addedBy: entity.addedBy,
            modifiedBy: entity.modifiedBy,
            createdDate: entity.createdDate,
            modifiedDate: entity.modifiedDate,
        };
    }
}

export class FilesAndFolders {
    files: File[];
    folders: Folder[];

    static map(entity: any): FilesAndFolders {
        const files: File[] = [];
        const folders: Folder[] = [];

        (entity.files || []).forEach((x) => files.push(File.map(x)));
        (entity.folders || []).forEach((x) => folders.push(Folder.map(x)));

        return {
            files: files,
            folders: folders,
        };
    }
}

export class MoveRequest {
    oldPath: string = "";
    newPath: string = "";
    isCopy: boolean;
    isReplace: boolean;
}

export class RenameFileRequest extends MoveRequest {
    newFileName: string = "";
}

export class RenameFileByUrlRequest {
    oldUrl: string = "";
    newPath: string = "";
    isCopy: boolean;
    newFileName: string = "";
    oldPathProjectId: any;
    resetLabel: boolean = false;
}

export class CreateUrlRequest {
    filename: string;
    path: string;
    url: string;
}

export class RenameModal {
    node: TreeNode;
    header: string;
    isNew: boolean;
    oldName: string;
    currentName: string;

    constructor(node: TreeNode, isNew: boolean) {
        this.header = isNew ? "Create" : "Rename";
        this.isNew = isNew;

        if (node) {
            this.header += " " + node.type;
            this.node = node;
            this.currentName = node.label;
            this.oldName = node.label;
        } else this.node = {};
    }
}

export class RevisionModal {
    node: TreeNode;
    name: string;
    versions: FileVersion[];
    loading: boolean = false;

    constructor(node: TreeNode) {
        if (node) {
            this.node = node;
            this.name = node.label;
        } else this.node = {};
    }
}

export class FileVersion {
    lastModified: Date;
    size: number;
    versionId: string;
    modifiedBy: string;
}
